import { createSlice } from '@reduxjs/toolkit';
import { clearState } from './clearSlice';

const initialState = {
   id: null,
   data: {},
   reactionGrid: {},
   virtualizedListRefs: {}, // 👈 store virtualized list refs by channelId
};

const draftSlice = createSlice({
   name: 'draftData',
   initialState,
   reducers: {
      toggleReactionGrid(state, action) {
         const { channelId, messageId } = action.payload;
         const key = `${channelId}_${messageId}`;
         state.reactionGrid[key] = !state.reactionGrid[key];
      },
      closeReactionGrid(state, action) {
         const { channelId, messageId } = action.payload;
         const key = `${channelId}_${messageId}`;
         state.reactionGrid[key] = false;
      },
      setReplyMessage(state, action) {
         const { userId, message } = action.payload;
         if (state.data[userId]) {
            state.data[userId] = { ...state.data[userId], replyMessage: message };
         } else {
            state.data[userId] = { replyMessage: message };
         }
      },
      setTextMessage(state, action) {
         const { userId, message } = action.payload;
         if (state.data[userId]) {
            state.data[userId] = { ...state.data[userId], text: message };
         } else {
            state.data[userId] = { text: message };
         }
      },
      setAudioRecording(state, action) {
         const { userId, message } = action.payload;
         if (state.data[userId]) {
            state.data[userId] = { ...state.data[userId], audioRecord: message };
         } else {
            state.data[userId] = { audioRecord: message };
         }
      },
      setAudioRecordingStatus(state) {
         state.data.isRecording = true;
      },
      resetAudioRecordingStatus(state) {
         state.data.isRecording = false;
      },
      setAudioRecordTime(state, action) {
         const { userId, time } = action.payload;
         if (state.data[userId]) {
            state.data[userId] = { ...state.data[userId], audioRecordTime: time };
         } else {
            state.data[userId] = { audioRecordTime: time };
         }
      },
      resetDaftData(state, action) {
         const userId = action.payload;
         delete state.data[userId];
      },
      setVirtualizedListRef(state, action) {
         const { channelId, ref } = action.payload;
         state.virtualizedListRefs[channelId] = ref;
      },
      clearVirtualizedListRef(state, action) {
         const { channelId } = action.payload;
         delete state.virtualizedListRefs[channelId];
      },
   },
   extraReducers: builder => {
      builder.addCase(clearState, () => initialState);
   },
});

export const {
   toggleReactionGrid,
   closeReactionGrid,
   setReplyMessage,
   setTextMessage,
   resetDaftData,
   setAudioRecording,
   setAudioRecordTime,
   setVirtualizedListRef,
   clearVirtualizedListRef,
   resetAudioRecordingStatus,
   setAudioRecordingStatus
} = draftSlice.actions;
export default draftSlice.reducer;
